<script setup lang="ts">
  withDefaults(
    defineProps<{
      title: string;
      subtitle?: string | null;
    }>(),
    { subtitle: null },
  );
</script>

<template>
  <div class="flex items-center min-h-8 py-2">
    <div class="flex-1 flex items-baseline min-w-0 gap-1">
      <div class="max-w-[70%] truncate text-13 font-medium text-primary">
        {{ title }}
      </div>
      <span
        v-if="subtitle"
        class="text-2xs font-semibold uppercase tracking-wider text-foreground-subtle">
        {{ subtitle }}
      </span>
    </div>
    <div class="flex justify-end items-center gap-2 shrink-0">
      <slot name="actions" />
    </div>
  </div>
</template>
